import Language from '@/language/Language';
import LanguageCode from '@/language/LanguageCode';

export default class Dutch implements Language {
    public get code(): LanguageCode {
        return LanguageCode.NL;
    }

    public get name(): string {
        return 'Nederlands';
    }
}
